import { render, staticRenderFns } from "./BlwCheckBox.vue?vue&type=template&id=da06abd0&"
import script from "./BlwCheckBox.vue?vue&type=script&lang=js&"
export * from "./BlwCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BlwCheckBox.vue?vue&type=style&index=0&id=da06abd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports